$(document).ready(function(){
    
    var winW = $(window).width();
    
    // Inicialización: Ocultar todos los textos excepto el primero
    $(".header-top .col02 .texts > .text").hide();
    $(".header-top .col02 .texts > .text:first").show();
    
    // Función para cambiar el texto visible
    function cambiarTexto() {
        var $current = $('.header-top .col02 .texts > .text:visible');
        var $next = $current.next('.text');
        
        // Si no hay siguiente, reinicia al primero
        if ($next.length === 0) {
            $next = $('.header-top .col02 .texts > .text:first');
        }
        
        // Detiene animaciones en curso y realiza fadeOut
        $current.stop(true, true).fadeOut(1000, function() {
            // Después de fadeOut, realiza fadeIn del siguiente elemento
            $next.stop(true, true).fadeIn(1000, function(){
                // Mueve el elemento actual al final para mantener el ciclo
                $current.appendTo('.header-top .col02 .texts');
                // Programa la próxima animación después de fadeIn + tiempo de espera
                setTimeout(cambiarTexto, 5000);
            });
        });
    }
    
    // Inicia la primera animación después de 5 segundos
    setTimeout(cambiarTexto, 5000);
	$('.header-top .col02 .text').click(function(){
		$('.topbar').addClass('show');
		$('.topbar .inner').addClass('show');
		$('body').addClass('locked');
	});
	$('.topbar .cerrar').click(function(e){
		e.preventDefault();
		$('.topbar').removeClass('show');
		$('.topbar .inner').removeClass('show');
		$('body').removeClass('locked');
	});

	$('.header2 .icons a.menu').click(function(e){
		e.preventDefault();
		$('.expand').addClass('show');
		$('.expand .row2').addClass('show');
		$('body').addClass('locked');
	});
	$('.expand .cerrar').click(function(e){
		e.preventDefault();
		$('.expand').removeClass('show');
		$('.expand .row2').removeClass('show');
		$('body').removeClass('locked');
	});
	
	if (winW > 993) {
		$('.submenu51').appendTo('.header2');
	  
	  $('.submenu51 .cerrar').click(function(e){
		e.preventDefault();
		$('.submenu51').removeClass('show');
	  });
  
	  $('.submenu51').on('click', '.subcol:not([data-level]), .subcol[data-level="1"]', function(e){
		if ($(e.target).is('a')) return;
		
		var $submenu = $(this).closest('.submenu51');
		var $menuDiv = $(this).find('.menu-div').first();
		var $header = $(this).find('h4').first();
		
		if ($menuDiv.length) {
		  e.preventDefault();
		  
		  if ($menuDiv.hasClass('show')) {
			$menuDiv.removeClass('show');
			$menuDiv.find('.cerrar.cerrar-full').remove();
			$header.removeClass('active');
			
			if ($submenu.find('.menu-div.show').length === 0) {
			$submenu.find('> .cerrar').show();
			$submenu.removeClass('expanded');
			}
		  } else {
			$submenu.find('.subcol h4').removeClass('active');
			$submenu.find('> .cerrar').hide();
			$submenu.find('.menu-div.show').not($menuDiv).each(function(){
			  $(this).removeClass('show').find('.cerrar.cerrar-full').remove();
			});
			
			$menuDiv.addClass('show');
			$header.addClass('active');
			if ($menuDiv.find('.cerrar.cerrar-full').length === 0) {
			  $menuDiv.prepend(`
				<svg class="cerrar cerrar-full" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.1 16.1">
				  <path d="M10.9 8.1l4.9-4.9c.4-.4.4-1 0-1.4L14.4.4c-.4-.4-1-.4-1.4 0L8.1 5.2 3.1.3c-.4-.4-1-.4-1.4 0L.3 1.7c-.4.4-.4 1 0 1.4L5.2 8 .3 13c-.4.4-.4 1 0 1.4l1.4 1.4c.4.4 1 .4 1.4 0L8 10.9l4.9 4.9c.4.4 1 .4 1.4 0l1.4-1.4c.4-.4.4-1 0-1.4l-4.8-4.9z"/>
				</svg>
			  `);
			}
			$submenu.addClass('expanded');
		  }
		}
	  });
  
	  $(document).on('click', '.menu-div .cerrar.cerrar-full', function(e){
		e.preventDefault();
		var $submenu = $(this).closest('.submenu51');
		$(this).closest('.menu-div').removeClass('show').find('.cerrar.cerrar-full').remove();
		$(this).closest('.subcol').find('h4').removeClass('active');
		
		if ($submenu.find('.menu-div.show').length === 0) {
		  $submenu.find('> .cerrar').show();
		  $submenu.removeClass('expanded');
		}
	  });
  

	} else {
		$('.submenu51 h4 a').removeAttr('href');
		$('.submenu51').appendTo('.expand');
		$('.submenu51').prepend('<span class="back"><svg viewBox="0 0 30 30" aria-labelledby="ahicon--cta-link--arrow-left-desc ahicon--cta-link--arrow-left-title" id="icon--cta-link--arrow-left" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><title id="ahicon--cta-link--arrow-left-title">cta link arrow left</title><desc id="ahicon--cta-link--arrow-left-desc">cta link arrow left</desc><path d="M13.9 9.1l-1.4-1.4c-.4-.4-1-.4-1.4 0L4 14.8c-.4.4-.4 1 0 1.4l1.4 1.4 5.7 5.7c.4.4 1 .4 1.4 0l1.4-1.4c.4-.4.4-1 0-1.4l-4.9-5 4.9-4.9c.4-.5.4-1.1 0-1.5z"></path></svg></span>');
		$('.submenu51 .back').click(function(){
			$('.submenu51').removeClass('show');
			$('.expand .row2').addClass('show');
			$('.expand').removeClass('fix');
			$('.submenu51').scrollTop(0);
		});
		
		$('.menu-div').prepend('<span class="back"><svg viewBox="0 0 30 30" aria-labelledby="ahicon--cta-link--arrow-left-desc ahicon--cta-link--arrow-left-title" id="icon--cta-link--arrow-left" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><title id="ahicon--cta-link--arrow-left-title">cta link arrow left</title><desc id="ahicon--cta-link--arrow-left-desc">cta link arrow left</desc><path d="M13.9 9.1l-1.4-1.4c-.4-.4-1-.4-1.4 0L4 14.8c-.4.4-.4 1 0 1.4l1.4 1.4 5.7 5.7c.4.4 1 .4 1.4 0l1.4-1.4c.4-.4.4-1 0-1.4l-4.9-5 4.9-4.9c.4-.5.4-1.1 0-1.5z"></path></svg></span>');
		$('.menu-div .back').on('click', function(){
			console.log('back');
			$('.menu-div').removeClass('show');
			$('.menu-div').scrollTop(0);
		});
		
		$('.submenu51 .inner').prepend('<span class="back"><svg viewBox="0 0 30 30" aria-labelledby="ahicon--cta-link--arrow-left-desc ahicon--cta-link--arrow-left-title" id="icon--cta-link--arrow-left" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><title id="ahicon--cta-link--arrow-left-title">cta link arrow left</title><desc id="ahicon--cta-link--arrow-left-desc">cta link arrow left</desc><path d="M13.9 9.1l-1.4-1.4c-.4-.4-1-.4-1.4 0L4 14.8c-.4.4-.4 1 0 1.4l1.4 1.4 5.7 5.7c.4.4 1 .4 1.4 0l1.4-1.4c.4-.4.4-1 0-1.4l-4.9-5 4.9-4.9c.4-.5.4-1.1 0-1.5z"></path></svg></span>');
		$('.submenu51 .inner .back').on('click', function(){
			console.log('back');
			$('.submenu51 .inner').removeClass('show');
			$('.submenu51 .inner').scrollTop(0);
		});
		
		$('.submenu51 h4').each(function(){
			$(this).click(function(e){
				var h4title = $(this).next('.menu-div').data('title');
				var h4title2 = $(this).next('.inner').data('title');
				$(this).next('.menu-div').addClass('show');
				$(this).next('.menu-div').prepend('<u>' + h4title + '</u>');
				$(this).next('.inner').addClass('show');
				$(this).next('.inner').prepend('<u>' + h4title2 + '</u>');
			});
		});
		
		$('.expand .cerrar').click(function(){
			$('.submenu51').removeClass('show');
			$('.submenu51 .menu-div').removeClass('show');
			$('.submenu51 .inner').removeClass('show');
			$('.expand .row2').removeClass('show');
			$('.expand').removeClass('show');
			$('.expand .row2').removeClass('show');
			$('.expand').scrollTop(0);
			$('.submenu51').scrollTop(0);
			$('.expand').removeClass('fix');
		});

		$('.minicart-menu').click(function(){
			$('.minicart-menu .dropdown-menu').toggle(100);
		});
	}
	
	// Scrolling
	
	$.fn.isInViewport = function() {
		var elementTop = $(this).offset().top * 1;
		var elementBottom = elementTop + $(this).outerHeight() * 1;
		var viewportTop = $(window).scrollTop();
		var viewportBottom = viewportTop + $(window).height();
		return elementBottom > viewportTop && elementTop < viewportBottom;
	};
	
	if (winW < 993) {
		
		$('.expand .row2 .cols51 .col51 h3').each(function(){
			$(this).click(function(){
				$(this).toggleClass('active');
				$(this).siblings('ul').slideToggle(200);
			}); 
		});
		
	}
	
	var lastScrollTop = 0;

	$(window).scroll(function() {
	var st = $(this).scrollTop();
	if (st === 0) {
		$('.header2, .product-sticky-menu').removeClass('fixed');
	} else {
		$('.header2').addClass('fixed');

		if (st > lastScrollTop) {
		$('.product-sticky-menu').addClass('fixed');
		} else if (st < lastScrollTop) {
		$('.product-sticky-menu').removeClass('fixed');
		}
	}

	lastScrollTop = st;
	});
	
	const cartForms = document.querySelectorAll(".product_form.product_form_options");

	setTimeout(() => {		
		cartForms.forEach(form => {
			form.addEventListener("submit", (e)=> {
				e.preventDefault();
			})
		});
	}, 500);
	
	const pathname = window?.location?.pathname;
	const history = localStorage.getItem('@history');
	if (history) {
		localStorage.setItem('@history', JSON.stringify([
			...JSON.parse(history),
			pathname
		]))
	} else {
		localStorage.setItem('@history', JSON.stringify([pathname]))
	}

});

$('.submenu51').on('click', '.subcol[data-level]:not([data-level="1"]) > h4', function(e){
    var winW = $(window).width();
    if ($(e.target).is('a')) return; 
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var $subcol = $(this).closest('.subcol');
    var level = $subcol.data('level');  
    var $childMenu = $subcol.find('.menu-div-level' + level).first();

    $subcol.closest('ul.menu')
           .find('.subcol[data-level="'+ level +'"]')
           .not($subcol)
           .each(function(){
               $(this).find('.menu-div-level' + level).removeClass('show');
           });

    function agregarCerrarFull($container) {
      $subcol.closest('.submenu51').find('.menu-div.show .cerrar.cerrar-full').remove();
      $container.prepend(`
        <svg class="cerrar cerrar-full" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.1 16.1">
          <path d="M10.9 8.1l4.9-4.9c.4-.4.4-1 0-1.4L14.4.4c-.4-.4-1-.4-1.4 0L8.1 5.2 3.1.3c-.4-.4-1-.4-1.4 0L.3 1.7c-.4.4-.4 1 0 1.4L5.2 8 .3 13c-.4.4-.4 1 0 1.4l1.4 1.4c.4.4 1 .4 1.4 0L8 10.9l4.9 4.9c.4.4 1 .4 1.4 0l1.4-1.4c.4-.4.4-1 0-1.4l-4.8-4.9z"/>
        </svg>
      `);
    }

    if (winW >= 831 && winW <= 993) {
         if (!$childMenu.hasClass('show')) {
             $childMenu.addClass('show');
             agregarCerrarFull($childMenu);
             $subcol.parents('.subcol').each(function(){
                 var parentLevel = $(this).data('level') || 1;
                 if (parentLevel < level) {
                     $(this).css({
                         opacity: '1',
                         transform: 'none'
                     });
                 }
             });
         }
    } else {
         if (!$childMenu.hasClass('show')) {
             $childMenu.addClass('show');
             agregarCerrarFull($childMenu);
             $subcol.parents('.subcol').each(function(){
                 var parentLevel = $(this).data('level') || 1;
                 if (parentLevel < level) {
                     $(this).css({
                         opacity: '1',
                         transform: 'none'
                     });
                 }
             });
         } else {
             $childMenu.removeClass('show');
            var $parentMenu = $subcol.closest('.menu-div.show');
            if($parentMenu.length) {
                $subcol.closest('.submenu51').find('.menu-div.show .cerrar.cerrar-full').remove();
                $parentMenu.prepend(`
                    <svg class="cerrar cerrar-full" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.1 16.1">
                      <path d="M10.9 8.1l4.9-4.9c.4-.4.4-1 0-1.4L14.4.4c-.4-.4-1-.4-1.4 0L8.1 5.2 3.1.3c-.4-.4-1-.4-1.4 0L.3 1.7c-.4.4-.4 1 0 1.4L5.2 8 .3 13c-.4.4-.4 1 0 1.4l1.4 1.4c.4.4 1 .4 1.4 0L8 10.9l4.9 4.9c.4.4 1 .4 1.4 0l1.4-1.4c.4-.4.4-1 0-1.4l-4.8-4.9z"/>
                    </svg>
                `);
            }
        }
    }

});




  